import React, { useState,useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import BackIcon from '../../Assets/back.png';
import AttachmentIcon from '../../Assets/attachment.png';
import DropdownIcon from '../../Assets/dropdown.svg';
import { sendClaimFormEmail } from '../../utils/emailService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import ReactGA from 'react-ga4'

const EIGHTEEN_WHEELER_ACCIDENT= '18-wheeler-accident';

const ClaimForm = () => {
    const navigate = useNavigate();
// Function to get the initial landing URL
let initialLandingUrl = null;
 
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";
 
  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }
 
  return initialLandingUrl;
};
 
// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};


// Function to get Form Details
const getFormDetails = () => {
  const path = window.location.pathname; 

  if (path === "/" || path === "") {
    return { formname: "Home Form" };
  }

  const pageKey = path.replace("/", ""); 

  const readable = pageKey
    .replace(/Main$/i, "") 
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .trim();

  return { formname: `${readable} Form` };
};
  const [pingUrl, setPingUrl] = useState("");
  const [certId, setCertId] = useState("");
  const [tokenUrl, setTokenUrl] = useState("");

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        state: '',
        accidentDate: '',
        accidentTime: '',
        accidentLocation: '',
        accidentDescription: '',
        otherVehicles: {
            truck: false,
            bus: false,
            car: false,
            others: false
        },
        documents: {
            policeReport: false,
            medicalReport: false,
            accidentPhotos: false
        },
        files: [],
        agreeToTerms: false,
        isHuman: false,
        needHelp: false
    });

    // Add errors state
    const [errors, setErrors] = useState({
        phone: '',
        email: '',
    });
  useEffect(() => {
    let observer;
    let timeoutId;

    const initializeTrustedForm = () => {
      // Check for initial values
      const checkInitialValues = () => {
        const certUrlField = document.querySelector(
          'input[name="xxTrustedFormCertUrl"]'
        );
        const tokenField = document.querySelector(
          'input[name="xxTrustedFormCertToken"]'
        );
        const pingUrlField = document.querySelector(
          'input[name="xxTrustedFormPingUrl"]'
        );

        if (certUrlField?.value) {
          setCertId(certUrlField.value);
          console.log("Initial cert_id:", certUrlField.value);
        }
        if (tokenField?.value) {
          setTokenUrl(tokenField.value);
          console.log("Initial tokenUrl:", tokenField.value);
        }
        if (pingUrlField?.value) {
          setPingUrl(pingUrlField.value);
          console.log("Initial pingUrl:", pingUrlField.value);
        }
      };

      // Set up mutation observer
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "value"
          ) {
            const fieldName = mutation.target.name;

            // Extract values from all TrustedForm fields
            const certUrlField = document.querySelector(
              'input[name="xxTrustedFormCertUrl"]'
            );
            const tokenField = document.querySelector(
              'input[name="xxTrustedFormCertToken"]'
            );
            const pingUrlField = document.querySelector(
              'input[name="xxTrustedFormPingUrl"]'
            );

            const certUrlValue = certUrlField?.value || "";
            const tokenValue = tokenField?.value || "";
            const pingUrlValue = pingUrlField?.value || "";

            // Update state with the correct values
            setCertId(certUrlValue);
            setPingUrl(pingUrlValue);
            setTokenUrl(tokenValue);

            // console.log("TrustedForm field update:", {
            //   fieldName,
            //   certId: certUrlValue,
            //   pingUrl: pingUrlValue,
            //   tokenUrl: tokenValue
            // });

            // Fetch cert data if we have a cert URL and it's the cert field that changed
            if (certUrlValue && fieldName === "xxTrustedFormCertUrl") {
              fetchCertData(certUrlValue);
            }
          }
        });
      });

      // Observe all TrustedForm fields for changes
      const fieldsToObserve = [
        "xxTrustedFormCertUrl",
        "xxTrustedFormCertToken",
        "xxTrustedFormPingUrl",
      ];

      fieldsToObserve.forEach((fieldName) => {
        const field = document.querySelector(`input[name="${fieldName}"]`);
        if (field) {
          observer.observe(field, { attributes: true });
          // console.log(`Observing field: ${fieldName}`);
        }
      });

      // Check for initial values after a delay to allow TrustedForm to load
      timeoutId = setTimeout(checkInitialValues, 1000);
    };

    // Initialize TrustedForm monitoring
    initializeTrustedForm();

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const fetchCertData = async (certUrl) => {
    try {
      const response = await fetch(certUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("TrustedForm Cert Data:", data);
      return data;
    } catch (error) {
      console.error("Error fetching TrustedForm cert:", error);
      return null;
    }
  };
    const [isSubmitting, setIsSubmitting] = useState(false);

    const states = [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
        'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
        'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
        'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
        'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
    ];

    // Add validation functions
    const validatePhoneNumber = (phone) => {
        // Remove all non-digit characters for validation
        const digitsOnly = phone.replace(/\D/g, '');
        // Check if exactly 10 digits
        return digitsOnly.length === 10;
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Special handling for phone to limit to 10 digits
        if (name === "phone") {
            // Only allow numbers, hyphens, spaces, parentheses and dots
            const sanitizedValue = value.replace(/[^\d\-\.\(\) ]/g, '');
            // Extract only digits for length check
            const digitsOnly = sanitizedValue.replace(/\D/g, '');
            // Limit to 10 digits
            if (digitsOnly.length > 10) {
                return; // Don't update state if more than 10 digits
            }
            setFormData(prev => ({
                ...prev,
                [name]: sanitizedValue
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        // Clear error when field is being edited
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }

        // Validate on change for immediate feedback
        if (name === "phone" && value && !validatePhoneNumber(value)) {
            setErrors(prev => ({
                ...prev,
                phone: "Please enter exactly 10 digits (e.g., 123-456-7890)"
            }));
        }

        if (name === "email" && value && !validateEmail(value)) {
            setErrors(prev => ({
                ...prev,
                email: "Please enter a valid email address"
            }));
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: checked
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: checked
            }));
        }
    };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        if (files.some(file => file.size > 5 * 1024 * 1024)) {
            alert('File size should not exceed 5MB');
            return;
        }
        setFormData(prev => ({
            ...prev,
            files: [...prev.files, ...files]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Validate form fields
        const newErrors = {
            phone: formData.phone && !validatePhoneNumber(formData.phone)
                ? "Please enter exactly 10 digits (e.g., 123-456-7890)"
                : "",
            email: formData.email && !validateEmail(formData.email)
                ? "Please enter a valid email address"
                : ""
        };

        setErrors(newErrors);

        // Check if there are any errors
        if (Object.values(newErrors).some(error => error)) {
            console.log('Validation errors:', newErrors);
            setIsSubmitting(false);
            return; // Don't submit if there are errors
        }

        if (!formData.agreeToTerms || !formData.isHuman) {
            alert('Please agree to terms and verify you are human');
            setIsSubmitting(false);
            return;
        }

        // Combine date and time for submission if needed
        const combinedData = {
            ...formData,certId,pingUrl,tokenUrl,
            accidentDateTime: formData.accidentDate && formData.accidentTime ?
                `${formData.accidentDate}T${formData.accidentTime}` : ''
        };

        console.log('Form submitted:', combinedData);

       await fetch(
  'https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata',
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      countryName: 'Usa',
      brandName: 'Personal Injury',
      websiteName: 'Truck Accident Lawsuit expert',
      formname: getFormDetails().formname,
      vertical: EIGHTEEN_WHEELER_ACCIDENT,
      data: {
        // ✅ Basic info
        name: combinedData.name,
        firstname: '',
        lastname: '',
        email: combinedData.email,
        phone: combinedData.phone,
      trustedFormToken: combinedData.certId,
      trustedFormPingUrl: combinedData.pingUrl,
      trustedFormCertUrl: combinedData.tokenUrl,
        // ✅ Location-related
        city: combinedData.city || '',
        state: combinedData.state,
        zipCode: combinedData.zipCode || '',
        fullAddress: combinedData.fullAddress || '',

        // ✅ Accident details
        accidentDateTime: combinedData.accidentDateTime,
        accidentDate: combinedData.accidentDate,
        accidentTime: combinedData.accidentTime,
        accidentLocation: combinedData.accidentLocation,
        accidentDescription: combinedData.accidentDescription,

        // ✅ Involved vehicles
        otherVehicles: {
          truck: combinedData.otherVehicles.truck,
          bus: combinedData.otherVehicles.bus,
          car: combinedData.otherVehicles.car,
          others: combinedData.otherVehicles.others,
        },

        // ✅ Uploaded documents
        documents: {
          policeReport: combinedData.documents.policeReport,
          medicalReport: combinedData.documents.medicalReport,
          accidentPhotos: combinedData.documents.accidentPhotos,
        },

        // ✅ Files & booleans
        files: combinedData.files || [],
        agreeToTerms: combinedData.agreeToTerms,
        isHuman: combinedData.isHuman,
        needHelp: combinedData.needHelp,

        // ✅ Tracking & meta
        ipAddress: await getIPAddress(),
        trustedFormCertUrl: certId,
trustedFormToken: tokenUrl,
trustedFormPingUrl: pingUrl,
        submissionDate: new Date().toISOString(),
        pageSource: getSourceUrl(),
      },
    }),
  }
);

        
        // Send email using EmailJS

sendClaimFormEmail(combinedData)
          .then(result => {
                if (result.success) {
                    toast.success('Your claim form has been submitted successfully!');
                    // Optionally reset form
                    setFormData({
                        name: '',
                        phone: '',
                        email: '',
                        state: '',
                        accidentDate: '',
                        accidentTime: '',
                        accidentLocation: '',
                        accidentDescription: '',
                        otherVehicles: {
                            truck: false,
                            bus: false,
                            car: false,
                            others: false
                        },
                        documents: {
                            policeReport: false,
                            medicalReport: false,
                            accidentPhotos: false
                        },
                        files: [],
                        agreeToTerms: false,
                        isHuman: false,
                        needHelp: false
                    });
                    ReactGA.event({
                       category: "Form",
                       action: "Submit",
                       label: "Claim Form"
                     });
 
                } else {
                    toast.error('Failed to submit form. Please try again.');
                    ReactGA.event({
                      category: "Form",
                      action: "Submission Failed",
                      label: 'Claim Form'
                    });
 
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            }
        );
    };

    return (
        <div className="w-full relative bg-[#f8f5ee] min-h-screen overflow-hidden text-left text-[23.63px] text-[#2c3c58] font-nunito">
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex items-center mb-8">
                    <img
                        src={BackIcon}
                        alt="Back"
                        className="w-[54px] h-[54px] cursor-pointer"
                        onClick={() => navigate(-1)}
                    />
                </div>

                <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold font-['EB_Garamond'] text-[#5d2446] text-center mb-12">
                    Big Rig Lawsuit- Free Case Review
                </h1>

                <form onSubmit={handleSubmit} className="space-y-12">
      {/* Hidden TrustedForm fields */}
                <input
                  type="hidden"
                  id="xxTrustedFormCertUrl"
                  name="xxTrustedFormCertUrl"
                  value={certId}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormCertToken"
                  name="xxTrustedFormCertToken"
                  value={tokenUrl}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormPingUrl"
                  name="xxTrustedFormPingUrl"
                  value={pingUrl}
                />

                    <div className="space-y-8">
                        <h2 className="text-2xl sm:text-3xl font-semibold font-['EB_Garamond'] text-[#5d2446] underline text-center">
                            Personal Information
                        </h2>

                        <div className="space-y-6 max-w-[970px] mx-auto">
                            <div className="relative">
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Name"
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none"
                                />
                            </div>

                            <div className="relative">
                                <div className="relative">
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        placeholder="Phone number"
                                        className={`w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none ${errors.phone ? "border-2 border-red-500" : ""}`}
                                    />
                                    {errors.phone && <p className="text-red-500 text-sm mt-1 ml-[45px]">{errors.phone}</p>}
                                </div>
                            </div>

                            <div className="relative">
                                <div className="relative">
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="E mail Address"
                                        className={`w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none ${errors.email ? "border-2 border-red-500" : ""}`}
                                    />
                                    {errors.email && <p className="text-red-500 text-sm mt-1 ml-[45px]">{errors.email}</p>}
                                </div>
                            </div>

                            <div className="relative">
                                <select
                                    name="state"
                                    value={formData.state}
                                    onChange={handleInputChange}
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-12 text-[#646464] border-none outline-none appearance-none"
                                >
                                    <option value="">Select State</option>
                                    {states.map(state => (
                                        <option key={state} value={state}>{state}</option>
                                    ))}

                                </select>
                                {/* <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                                    <img src={DropdownIcon} alt="" className="w-[37.8px] h-[37.8px]" />
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="space-y-8">
                        <h2 className="text-2xl sm:text-3xl font-semibold font-['EB_Garamond'] text-[#5d2446] underline text-center">
                            Accident Details
                        </h2>

                        <div className="space-y-6 max-w-[970px] mx-auto">
                            <div className="relative">
                                <label htmlFor="accidentDate" className="block mb-2 text-xl font-medium">Date of Accident</label>
                                <input
                                    type="date"
                                    id="accidentDate"
                                    name="accidentDate"
                                    value={formData.accidentDate}
                                    onChange={handleInputChange}
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none"
                                />
                            </div>

                            <div className="relative">
                                <label htmlFor="accidentTime" className="block mb-2 text-xl font-medium">Time of Accident</label>
                                <input
                                    type="time"
                                    id="accidentTime"
                                    name="accidentTime"
                                    value={formData.accidentTime}
                                    onChange={handleInputChange}
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none"
                                />
                            </div>

                            <div className="relative">
                                <input
                                    type="text"
                                    name="accidentLocation"
                                    value={formData.accidentLocation}
                                    onChange={handleInputChange}
                                    placeholder="Accident Location (Street, City)"
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none"
                                />
                            </div>

                            <div className="relative">
                                <input
                                    type="text"
                                    name="accidentDescription"
                                    value={formData.accidentDescription}
                                    onChange={handleInputChange}
                                    placeholder="What happened?"
                                    className="w-full h-[72px] rounded-[28px] bg-white pl-[45px] pr-4 text-[#646464] border-none outline-none"
                                />
                            </div>

                            <div className="space-y-4">
                                <h3 className="text-xl font-medium">Other vehicle involved</h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            name="otherVehicles.truck"
                                            checked={formData.otherVehicles.truck}
                                            onChange={handleCheckboxChange}
                                            className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                        />
                                        <span>18-Wheeler Truck</span>
                                    </label>
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            name="otherVehicles.bus"
                                            checked={formData.otherVehicles.bus}
                                            onChange={handleCheckboxChange}
                                            className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                        />
                                        <span>Bus</span>
                                    </label>
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            name="otherVehicles.car"
                                            checked={formData.otherVehicles.car}
                                            onChange={handleCheckboxChange}
                                            className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                        />
                                        <span>Car</span>
                                    </label>
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            name="otherVehicles.others"
                                            checked={formData.otherVehicles.others}
                                            onChange={handleCheckboxChange}
                                            className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                        />
                                        <span>Others</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-8">
                        <h2 className="text-2xl sm:text-3xl font-semibold font-['EB_Garamond'] text-[#5d2446] underline text-center">
                            Supporting Documents
                        </h2>

                        <div className="space-y-6 max-w-[970px] mx-auto">
                            <p className="text-xl font-medium">Upload Files (Max 5MB each, JPG/PNG/PDF)</p>

                            <div className="relative rounded-[28px] bg-white p-4 h-[122px]">
                                <div className="flex items-center space-x-4">
                                    <div className="w-[37.8px] h-[37.8px]">
                                        <img src={AttachmentIcon} alt="" className="w-[23.9px] h-[23.9px]" />
                                    </div>
                                    <input
                                        type="file"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={handleFileUpload}
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="documents.policeReport"
                                        checked={formData.documents.policeReport}
                                        onChange={handleCheckboxChange}
                                        className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                    />
                                    <span>Police Report</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="documents.medicalReport"
                                        checked={formData.documents.medicalReport}
                                        onChange={handleCheckboxChange}
                                        className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                    />
                                    <span>Medical Report</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="documents.accidentPhotos"
                                        checked={formData.documents.accidentPhotos}
                                        onChange={handleCheckboxChange}
                                        className="w-[18.9px] h-[18.9px] rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                                    />
                                    <span>Accident Photos</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6 max-w-[970px] mx-auto">
                        <label className="flex items-start space-x-2">
                            <input
                                type="checkbox"
                                name="needHelp"
                                checked={formData.needHelp}
                                onChange={handleCheckboxChange}
                                className="w-[18.9px] h-[18.9px] min-w-[18.9px] min-h-[18.9px] flex-shrink-0 rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                            />
                            <span>I would be needing help to file a claim?</span>
                        </label>

                        <label className="flex items-start space-x-2">
                            <input
                                type="checkbox"
                                name="agreeToTerms"
                                checked={formData.agreeToTerms}
                                onChange={handleCheckboxChange}
                                className="w-[18.9px] h-[18.9px] min-w-[18.9px] min-h-[18.9px] flex-shrink-0 rounded-[4.73px] border-[1.2px] border-[#bf8bd3] mt-[5px]"
                            />
                            <span >
                                I agree to the <Link to="/privacy" className="text-[#733139] hover:underline">privacy policy</Link> and <Link to="/disclaimer" className="text-[#733139] hover:underline">disclaimer</Link> and give my express written consent, affiliates and/or attorneys to contact you at the number provided above, even if this number is a wireless number or if i am presently listed on a <span className="font-medium text-[#733139]">DO NOT CALL</span> list, I understand that i may be contacted by telephone, email, text message or mail regarding case options that i may be called using automatic dialing equipment. Message and data rates may apply. My consent does not require purchase. This is Legal advertising.
                            </span>
                        </label>

                        <label className="flex items-start space-x-2">
                            <input
                                type="checkbox"
                                name="isHuman"
                                checked={formData.isHuman}
                                onChange={handleCheckboxChange}
                                className="w-[18.9px] h-[18.9px] min-w-[18.9px] min-h-[18.9px] flex-shrink-0 rounded-[4.73px] border-[1.2px] border-[#bf8bd3]"
                            />
                            <span>Please click this box so we know you're a person and not computer.</span>
                        </label>
                    </div>


                    <div className="flex justify-center">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`rounded-[14.18px] bg-[#ffc72c] w-[486.8px] h-[67.3px] text-black font-montserrat font-semibold uppercase hover:bg-[#ffd966] transition-colors duration-200 flex items-center justify-center ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                        >
                            {isSubmitting ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    SUBMITTING...
                                </>
                            ) : (
                                'SUBMIT'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClaimForm;
